import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyPrimaryData } from "services";

import { FOOTPRINTING_DAIRY, FOOTPRINTING_DAIRY_PRIMARY_DATA } from "consts";

import { FootprintingDairyPrimaryData } from "models";

export const useMutateFootprintingDairyPrimaryData = (
  farmId: string,
  year: number,
  payload: Omit<FootprintingDairyPrimaryData, "id">,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_PRIMARY_DATA],
      mutationFn: () => setFootprintingDairyPrimaryData(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId],
          [FOOTPRINTING_DAIRY_PRIMARY_DATA, farmId, year],
          [FOOTPRINTING_DAIRY, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
